import script from "./partner.vue?vue&type=script&setup=true&lang=js"
export * from "./partner.vue?vue&type=script&setup=true&lang=js"

import "./partner.vue?vue&type=style&index=0&id=432d2cb5&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-432d2cb5"]])

export default __exports__